import React, { FC } from 'react';

import { LinksKeys } from 'constants/links';

import { useStyles } from './styles';

export interface SecondaryFooterProps {}

export const Footer: FC<SecondaryFooterProps> = (): JSX.Element => {
    const {
        footer,
        footerContent,
        links,
        contentBlock,
        companyInfo
    } = useStyles();

    const userPolicyLinksList =
        <>
            <a href={LinksKeys.TermsAndCondition} target='_blank' rel='noreferrer'>Terms and Conditions</a>
            <a href={LinksKeys.PrivacyPolicy} target='_blank' rel='noreferrer'>Privacy Policy</a>
            <a href={LinksKeys.RefundPolicy} target='_blank' rel='noreferrer'>Refund Policy</a>
        </>;

    const companyAddress = '65 Compton Street, London, United Kingdom';
    const companyPhoneNumber = '0203 868 6308';

    return (
        <footer className={footer}>
            <div className={footerContent}>
                <div className={contentBlock}>
                    <div className={companyInfo}>
                        <span>{companyAddress}</span>
                        <span>{companyPhoneNumber}</span>
                    </div>
                    <div className={links}>
                        {userPolicyLinksList}
                    </div>
                </div>
            </div>
        </footer>
    );
};
